import { Spin } from './component';

export * from './component';
export default Spin;
